import { Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';

interface MobileSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const MobileSearchBar = ({ value, onChange, placeholder }: MobileSearchBarProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.25,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'grey.300',
        bgcolor: 'common.white',
        width: '100%',
      }}
    >
      <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
      <InputBase
        placeholder={placeholder ?? t('mobileSearch')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          flex: 1,
          '& input': {
            padding: 0,
            fontSize: '16px',
            color: 'text.primary',
            '&::placeholder': { color: 'grey.500', opacity: 1 },
          },
        }}
      />
      {value && (
        <HighlightOffIcon
          onClick={() => onChange('')}
          sx={{ fontSize: 22, color: 'text.secondary', cursor: 'pointer' }}
        />
      )}
    </Box>
  );
};

export default MobileSearchBar;
